export default {
   commentsData: {
      data: [],
   },
   fetchData: true,
   fetchNewData: false,
};
